module.exports = __webpack_public_path__ + "static/media/Llibre_obert_PURPLE.925f1d37.svg";